import { CurrencyEnum } from 'types/entities/fee.entity';

export const currencyOptions = Object.values(CurrencyEnum).map(
  (curr: CurrencyEnum, index: number) => {
    return { value: curr, label: curr.toUpperCase() };
  }
);
